<span><pre class="text">{{text}}</pre></span>